import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import BackgroundRounds from "./components/BackgroundRounds";
import Header from "./partials/Header";
import Layout from "./partials/Layout";
import Modals from "./modals";
import Web3Context from "./contexts/Web3Context";

export default function () {
  const showPopup = !!useSelector((state) => state.modal.window);

  useEffect(() => {
    document.body.style.overflow = showPopup ? "hidden" : "";
    document.body.style.paddingRight = showPopup ? "8px" : "";
  }, [showPopup]);

  return (
    <Web3Context>
      <div className="page">
        <picture className="gradient-background">
          <source
            srcSet="/assets/images/header/gradient-mobile.png"
            media="(max-width: 656px)"
            type="image/png"
          />
          <source
            srcSet="/assets/images/header/gradient.webp"
            type="image/webp"
          />
          <img
            src="/assets/images/header/gradient.png"
            alt="img"
            className="gradient"
          />
        </picture>

        <picture>
          <source
            srcSet="/assets/images/header/logo@2x.png 2x"
            type="image/png"
          />
          <img
            src="/assets/images/header/logo.png"
            alt="img"
            className="logo"
          />
        </picture>
        <div className="rounds-background">
          <div className="rounds-background__wrapper container">
            <BackgroundRounds className="rb-item rb-item__first" />
            <BackgroundRounds className="rb-item rb-item__second" />
            <BackgroundRounds className="rb-item rb-item__third" />
            <BackgroundRounds className="rb-item rb-item__fourth" />
          </div>
        </div>
        <Header />
        <Layout />
        <Modals />
      </div>
    </Web3Context>
  );
}
